import {CommonConstant, NumberUnit} from '../app.constants';

export class NumberUtils {
  static normalizeNumberToString(value: number, decimals: number = 0): string {
    let dividedNumber;
    if (value > NumberUnit.BILLION) {
      return `+1${CommonConstant.BILLION_SYMBOL}`;
    } else if (value > NumberUnit.MILLION) {
      dividedNumber = value / NumberUnit.MILLION;
      return dividedNumber.toFixed(NumberUtils.calculateFractionDigit(dividedNumber)) + CommonConstant.MILLION_SYMBOL;
    } else if (value >= NumberUnit.THOUSAND) {
      dividedNumber = value / NumberUnit.THOUSAND;
      return dividedNumber.toFixed(NumberUtils.calculateFractionDigit(dividedNumber)) + CommonConstant.THOUSAND_SYMBOL;
    } else {
      return Math.round(value).toFixed(0);
    }
  }

  static calculateFractionDigit(number) {
    if ((number % 1) === 0) {
      return 0;
    }
    if (number >= 100) {
      return 0;
    } else {
      return 1;
    }
  }

  /**
   * the method used to convert number to string as formatter (XXX,XXX,XXX,XXX)
   * Example:
   * 11650 should be formatted 11,650
   * 120 should be formatted 120
   * 1000000 should be formatted 1,000,000
   * @param value
   * @returns {string}
   */
  static formatNumberToString(value, fractionDigits = 0) {
    return Number(value).toFixed(fractionDigits).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /**
   * This method is used for convert interaction value to '-' for unauthorised stories.
   * We also apply this logic to authorised stories with 0 interactions since we have many authorised stories collected
   * before we started tracking story interactions.
   */
  static formatInteractionNumber(value: number, authorized: boolean, story: boolean, decimals: number = 0): string {
    if (story && (!authorized || value === 0)) {
      return '-';
    } else {
      return NumberUtils.normalizeNumberToString(value, decimals);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/number.utils.ts